import * as z from "zod";
import { LSCustomerBaseDefaultsSchema } from "./base-defaults";
import { LSPriceRatesSchema } from "../price-rates";
import { LSBookingProfileSchema } from "../booking-profile";
import { LSLocalitySchema } from "../locality";
import { LSVehicleTypesSchema } from "../vehicle-types";
import { LSJobAccessorySchema } from "../job/accessory";

export const LSCustomerDefaultsSchema = z
	.object({
		baseDefaults: LSCustomerBaseDefaultsSchema.optional().default({} as z.output<typeof LSCustomerBaseDefaultsSchema>),
		userDefaultsPriceRates: z.array(LSPriceRatesSchema).optional().default([]),
		userDefaultsBookingProfiles: z.array(LSBookingProfileSchema).optional().default([]),
		userDefaultsVehicleTypes: z.array(LSVehicleTypesSchema).optional().default([]),

		localities: z.array(LSLocalitySchema).optional().default([]),
		itemCats: z.array(z.string()).optional().default([]),

		accessories: z.array(LSJobAccessorySchema).optional().default([]),
	})
	.transform((data: any) => {
		return {
			baseDefaults: data.baseDefaults ?? {},
			priceRates:
				data.userDefaultsPriceRates?.map((priceType: any, index: any) => {
					return {
						id: index,
						value: priceType.priceRateID,
						label: priceType.priceRateName,
					};
				}) || [],
			bookingProfiles: data.userDefaultsBookingProfiles ?? [],
			vehicleTypes: data.userDefaultsVehicleTypes ?? [],
			accessories: data.accessories ?? [],
			localities: data.localities ?? [],
			itemCats: data.itemCats ?? [],
		};
	});

export type LSCustomerDefaults = z.infer<typeof LSCustomerDefaultsSchema>;
